import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    CircularProgress,
    Divider,
    MenuItem,
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";

const CreateModelDevelopmentProjectModal = ({
    newProjectDetails,
    setNewProjectDetails,
    createProjectModal,
    handleCreateProjectModalClose,
    handleCreateProject,
    projectCreationLoader,
}) => {
    return (
        <Dialog
            open={createProjectModal}
            onClose={handleCreateProjectModalClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Create New Model Development Project
            </DialogTitle>
            <Divider />

            <DialogContent>
                <TextField
                    label="Project Name"
                    value={newProjectDetails.name || ""}
                    onChange={(e) =>
                        setNewProjectDetails({
                            ...newProjectDetails,
                            name: e.target.value,
                        })
                    }
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Project Description"
                    value={newProjectDetails.description || ""}
                    onChange={(e) =>
                        setNewProjectDetails({
                            ...newProjectDetails,
                            description: e.target.value,
                        })
                    }
                    fullWidth
                    margin="normal"
                    multiline
                    rows={4}
                />

            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleCreateProjectModalClose}
                    color="transparent"
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleCreateProject}
                    color="quCreateColor"
                    disabled={projectCreationLoader || !newProjectDetails.name || !newProjectDetails.description}
                >
                    {projectCreationLoader ? (
                        <CircularProgress size={20} color="inherit" />
                    ) : (
                        "Create"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateModelDevelopmentProjectModal;
